import { Col, DropdownMenu, Nav, Row } from 'reactstrap';
import { athensGray } from 'components/style/Colors.style';
import styled from 'styled-components';

export const UserNav = styled(Nav).attrs({
  navbar: true,
  className: 'ml-auto pl-3'
})``;

export const Menu = styled(DropdownMenu)`
  right: 0;
`;

export const LabelRow = styled(Row).attrs({
  className: 'mx-0'
})``;

export const LabelCol = styled(Col).attrs({
  xs: 'auto',
  className:
    'p-0 pr-2 d-flex justify-content-end align-items-end align-self-center flex-column'
})``;

export const AvatarCol = styled(Col).attrs({
  xs: 'auto',
  className: 'p-0'
})``;

export const Avatar = styled.img.attrs({
  className: 'img-fluid float-left m-auto',
  alt: 'avatar'
})``;

const DropdownLabel = styled.span`
  font-size: 10.6px;
  letter-spacing: 0.6px;
  text-align: right;
`;

export const Label = DropdownLabel.extend`
  color: ${athensGray};
`;

export const PositionLabel = DropdownLabel.extend`
  font-weight: lighter;
  color: ${athensGray};
`;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/UserDropdown/UserDropdown.style.js